import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

export function useFadeUp(selector: string, options = {}) {
  useGSAP(() => {
    const fadeUp = document.querySelectorAll(selector);
    fadeUp.forEach(function (element) {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
        },
        duration: 0.5,
        opacity: '0',
        y: '20%',
        ...options,
      });
    });
  });
}

export default useFadeUp;
